<template>
    <div v-html="spriteRaw" style="display: none"></div>
    <router-view name="mobHeader"></router-view>
    <router-view name="deskHeader" :is-baza="true"></router-view>

    <router-view/>

    <router-view name="footer"></router-view>
    <popup-component
        :show="popups.personalData.show" :name="popups.personalData.name" :width="704">
        <contract-offer-modal></contract-offer-modal>
    </popup-component>
    <popup-component
        :show="popups.contractOfferModal.show" :name="popups.contractOfferModal.name" :width="704">
        <personal-data-modal></personal-data-modal>
    </popup-component>

    <CookieComponent/>
    <ImproveModal  v-if="store.improveModal" :sectionName="'baza'"></ImproveModal>
    <span class="font-light"></span>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PopupComponent from '@baza/components/PopupComponent.vue';
import CookieComponent from '@baza/components/CookieComponent.vue';
import ContractOfferModal from './components/modals/ContractOfferModal.vue';
import PersonalDataModal from './components/modals/PersonalDataModal.vue';
import spriteSvg from '@baza/assets/img/sprite.svg?raw';
import ImproveModal from '@/components/Draft/ImproveModal.vue';
import { useStore } from '@/store/store.ts';

export default {
    name: 'App',
    components: {
        PopupComponent,
        ContractOfferModal,
        PersonalDataModal,
        CookieComponent,
        ImproveModal,
    },
    props: {
    },
    setup() {
      const store = useStore();
      return {
        store,
      }
    },
    data() {
        return {
          viewport: false,
          spriteRaw: false,
        };
    },
    mounted() {
        this.getCsrf();
        this.viewport = document.querySelector('meta[name=viewport]');
        this.checkWindowSize(); // Проверка размера окна
        this.isMacOs(); // Проверка на мак ос
        window.addEventListener('resize', () => {
            this.checkWindowSize();
        }, true);
        this.spriteRaw = spriteSvg;
    },
    computed: {
        ...mapState({
            popups: (state) => state.popups.items,
            currentlyActivePopup: (state) => state.popups.currentlyActive,
            isDesktop: (state) => state.isDesktop,
        }),
    },
    watch: {
        $route() {
            document.getElementsByTagName('body')[0].classList.remove('noscroll');
            if (this.currentlyActivePopup) {
                this.close(this.popups[this.currentlyActivePopup]);
            }
        },
    },
    methods: {
        ...mapActions('popups', [
            'close',
        ]),
        ...mapActions(['setIsDesktop']),
        ...mapActions('category', ['getCsrf']),
        setDesktopViewport() {
            document.querySelector('body').classList.remove('mobile-device');
            document.querySelector('body').classList.add('desktop-device');
            this.viewport.setAttribute('content', 'width=device-width, initial-scale=1');
            this.setIsDesktop(true);
        },
        setMobileViewport() {
            document.querySelector('body').classList.remove('desktop-device');
            document.querySelector('body').classList.add('mobile-device');
            if (this.$route.params.landing) {
                this.viewport.setAttribute('content', 'width=375');
            } else {
                this.viewport.setAttribute('content', 'width=320');
            }
            this.setIsDesktop(false);
        },
        checkWindowSize() {
          if (window.innerWidth > 991) {
                this.setDesktopViewport();
            } else {
                this.setMobileViewport();
            }
        },
        isMacOs() {
            const scrollWidth = window.innerWidth - document.documentElement.clientWidth;
            if (+scrollWidth === 0) {
                document.getElementsByTagName('body')[0].classList.add('scroll-mac-os');
            }
        },
    },
};
</script>

<style lang="sass">
@use "~@baza/assets/sass/style.sass" as *

.font-light
  font-family: 'SFProDisplay', sans-serif
  font-weight: 300
#app
  font-family: $default-font
.modal.--improve
  top: -1px
  padding-bottom: 50px !important
  z-index: 8080 !important
  .success
    p
      min-width: 296px
  +for-size(992)
    background-color: rgba(36, 36, 36, 0.93) !important
    top: 0px
    padding: 60px !important
  .wrapper
    min-width: 320px !important
    border-radius: 0
    margin: 0
    +for-size(992)
      min-width: 360px
      border-radius: 12px
      margin: auto auto
.header
  display: flex !important
  +for-size(992)
    display: none !important
.design-header
  +for-size(0)
    display: none !important
  +for-size(992)
    display: block !important
    height: 56px !important
    .inner_wrapper
      padding: 0 48px !important
    .logo
      font-size: 20px !important
  nav
    +for-size(992)
      display: flex !important
  .improve
    +for-size(992)
      display: block !important
</style>
